import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ImportserialService } from '../../services/importserial.service';
import { ProductSelectionService } from '../../services/product-selection.service';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';

@Component({
  selector: 'app-productvisibility-list',
  templateUrl: './productvisibility-list.component.html',
  styleUrl: './productvisibility-list.component.scss'
})
export class ProductvisibilityListComponent implements OnChanges, OnInit {

  displayProductSelectionModal: boolean = false;
  @Input() preview: boolean = false;
  @Input() fromRule: boolean = false;
  @Input() viewOnly: boolean = false;
  @Input() selectedChannel: any = null;
  @Input() headerText: string = '';
  @Input() selectedProductsList = [];
  @Input() productChannels = [];
  @Input() ruleList: SavedSearchNS.IRuleList[] = [];
  @Output() onCancelClicked = new EventEmitter();
  @Output() onProductAddComplete = new EventEmitter();

  modelChanged = new Subject<string>();
  productGlobalSearch: string = '';
  productCols = [
    {
      field: "productId",
      header: "ID",
      show: false,
      checked: false,
      fieldDataType: "number",
    },
    {
      field: "itemno",
      header: "Item No.",
      show: true,
      checked: true,
      fieldDataType: "string"
    },
    {
      field: "description",
      header: "Item Desc",
      show: true,
      checked: true,
      fieldDataType: "string"
    },
    {
      field: "price",
      header: "Sale Price",
      show: true,
      checked: true,
      fieldDataType: "currency"
    }
  ];
  pageNumber: number = 1;
  pageSize: number = 15;
  totalRecord: number = 0;
  tableShowMore: number[] = [15, 30, 50, 100];
  first: number = 0;
  // fraction digits
  fractionDigits: number = 0;
  allProducts = [];
  noProductFoundOrLoadingText: string = 'Loading...';
  filters = [];
  /**productList Payload for Product Visibility**/
  productPayLoad: string = '';
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private importService: ImportserialService, private service: ProductSelectionService,
    private appMainService: AppMainService) {
    this.modelChanged.pipe(
      debounceTime(700))
      .subscribe(() => {
        this.onGlobalSearch();
      })
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.noProductFoundOrLoadingText = 'Loading...';
    this.productGlobalSearch = '';
    if (changes.selectedProductsList && changes.selectedProductsList.currentValue) {
      this.selectedProductsList = changes.selectedProductsList.currentValue;
    }
    if (changes.fromRule?.currentValue && changes.ruleList?.currentValue) {
      this.filters = changes.ruleList.currentValue;
    }
    if (changes.preview?.currentValue) {
      this.displayProductSelectionModal  = changes.preview.currentValue;
     
    }
    if (changes.selectedChannel && changes.selectedChannel.currentValue) {
      this.getProducts(this.pageNumber, this.pageSize, this.selectedChannel?.id, this.filters, this.productGlobalSearch);
    }
  }

  ngOnInit(): void {
    this.importService
      .getDecimalValue()
      .subscribe({
        next: (value) => {
          if (value) {
            this.fractionDigits = value;
          }
        },
        error: (error) => { },
      });
  }

  changed() {
    this.modelChanged.next("");
  }

  onGlobalSearch() {
    this.pageNumber = 1;
    this.first = 0;
    this.getProducts(this.pageNumber, this.pageSize, this.selectedChannel?.id, this.filters, this.productGlobalSearch);
  }

  addProduct() {
    const prdObj = {
      selectedReccords: this.selectedProductsList,
      productPayLoad: (this.fromRule) ? this.productPayLoad : ''
    }
    this.onProductAddComplete.emit(prdObj);
  }

  onRowUnselect(event) {
    this.selectedProductsList = this.selectedProductsList?.filter(product => product.productId != event?.data?.productId);
  }

  onPageChange(event) {
    this.pageNumber = event.first / event.rows + 1;
    this.pageSize = event.rows;
    this.first = event.first;
    this.getProducts(this.pageNumber, this.pageSize, this.selectedChannel?.id, this.filters, this.productGlobalSearch);
  }

  getProducts(pageNumber: number, pageSize: number, typeId: number, filters, searchValue: string) {
    this.noProductFoundOrLoadingText = "Loading...";
    const ids = this.selectedProductsList.map(item => item?.productId);
    const cols = this.productCols?.map(col => ({
      ColumnName: col.field,
      IsCustom: false
    }))
    const obj = {
      Ids: this.viewOnly ? ids : [],
      WarehouseId: 0,
      ChannelId: typeId,
      IsActive: true,
      GlobalSearchValue: searchValue,
      SelectableColumns: cols,
      PageSize: pageSize,
      PageNumber: pageNumber,
      SortByColumn: '',
      SortByColumnDataType: '',
      IsSortByAscending: true,
      FilterInColumns: filters
    }
    this.productPayLoad = JSON.stringify(obj);
    this.service.getProductVisibilityData(obj).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          let { inventory, headers } = res;
          inventory = inventory ?? [];
          headers = headers ?? [];
          this.allProducts = inventory.list;
          this.totalRecord = inventory.totalNumberOfRows;
          this.appMainService.isHideSpinner("loadData");
          if(this.allProducts.length == 0){
            this.noProductFoundOrLoadingText = "No Products found.";
          }
          if(!this.preview && this.fromRule){
            this.addProduct();
          }
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
          this.noProductFoundOrLoadingText = "No Products found.";
        },
      });
  }

  cancelModal() {
    this.displayProductSelectionModal = false;
    this.onCancelClicked.emit({});
  }

}
